<template>
  <div class="inline-block text-left lg:relative">
    <div ref="button">
      <slot name="button" />
    </div>
    <div
      class="fixed left-0 top-0 z-30 size-full shadow-dropdown sm:w-auto md:absolute md:top-auto md:ml-8 md:mt-6 md:h-auto md:p-0 lg:ml-0"
      :class="[classProp, { hidden: !modelValue }]"
    >
      <div ref="content" class="dropdown-body h-full rounded-md bg-white shadow-lg md:h-auto">
        <div class="relative h-14 border-gray-6 md:h-auto md:border-b md:pb-3" :class="{ 'md:hidden': !showHeaderOnDesktop }">
          <a href="#" class="absolute left-0 top-0 m-1 mt-3 block p-4 md:left-auto md:right-0" @click.prevent="$emit('update:modelValue', false)">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 9.46788L1.46794 16L0 14.532L6.53206 7.99992L0.000156405 1.46796L1.4681 0L8 6.53196L14.5319 0L15.9998 1.46796L9.46794 7.99992L16 14.532L14.5321 16L8 9.46788Z" fill="#4D4D4D" />
            </svg>
          </a>
          <div v-if="mobileTitle" class="pt-5 text-center text-26px font-medium text-gray-dark">
            {{ mobileTitle }}
          </div>
        </div>
        <div class="dropdown-content md:height-auto overflow-y-auto p-5 pb-4 md:overflow-visible md:p-8" :class="{ 'has-footer': !!$slots.footer }">
          <slot />
        </div>
        <div v-if="$slots.footer" class="dropdown-footer border-gray-6 px-5 py-7 shadow-dropdown-footer md:mt-3 md:border-t md:px-8 md:shadow-none">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobileTitle: { type: String, default: '' },
    modelValue: Boolean,
    classProp: { type: String, default: '' },
    hideOnClickOutside: { type: Boolean, default: true },
    showHeaderOnDesktop: { type: Boolean, default: false },
  },

  emits: ['update:modelValue'],

  beforeUnmount () {
    document.removeEventListener('click', this.documentClick)
  },

  mounted () {
    document.addEventListener('click', this.documentClick)
  },

  methods: {
    documentClick (e) {
      if (! this.hideOnClickOutside || ! this.$refs.content || ! this.modelValue) { return }
      if (! this.$refs.content.contains(e.target) && ! this.$refs.button.contains(e.target)) {
        this.$emit('update:modelValue', false)
      }
    },
  },
}
</script>

<style lang="scss">
  .dropdown-content.has-footer {
    height: calc(100% - 9.5rem);
  }
  @media(max-width: 850px) {
    .dropdown-content.has-footer {
      height: calc(100% - 9.5rem - 67px);
    }
  }
</style>
